export const isSortQuery = (query: string) => /[a-z]+,(desc|asc)/.test(query);
